import React, { useEffect, useState } from 'react';
import { CalculatorIcon, DollarSignIcon, PieChartIcon, TrendingUpIcon, BuildingIcon } from 'lucide-react';
import { LoanCalculator } from '../components/tools/LoanCalculator';
import { SavingsCalculator } from '../components/tools/SavingsCalculator';
import { BudgetPlanner } from '../components/tools/BudgetPlanner';
import { InvestmentCalculator } from '../components/tools/InvestmentCalculator';
import { PortfolioCashflow } from '../components/tools/PortfolioCashflow';
type TabType = 'loan' | 'savings' | 'budget' | 'investment' | 'portfolio';
export function ToolsPage() {
  const [activeTab, setActiveTab] = useState<TabType>('portfolio');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const tabs = [{
    id: 'portfolio',
    label: 'Portfolio Pulse Check',
    icon: BuildingIcon
  }, {
    id: 'loan',
    label: 'Loan Calculator',
    icon: CalculatorIcon
  }, {
    id: 'savings',
    label: 'Savings Goal',
    icon: DollarSignIcon
  }, {
    id: 'budget',
    label: 'Budget Planner',
    icon: PieChartIcon
  }, {
    id: 'investment',
    label: 'Investment Growth',
    icon: TrendingUpIcon
  }];
  return <main className="pt-24 pb-24 bg-[#f8f9fb] dark:bg-[#0f1629] min-h-screen transition-colors duration-300" data-id="element-1623">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1624">
        <div className="text-center mb-12" data-id="element-1625">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-1626">
            <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-1627">
              Interactive Tools
            </span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-1628">
            Understand Your Position
          </h1>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-1629">
            Whether you're modelling portfolio growth or understanding your
            borrowing position — start here, then get in touch to build the
            strategy.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-1630">
          {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return <button key={tab.id} onClick={() => setActiveTab(tab.id as TabType)} className={`flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 rounded-xl font-medium text-sm transition-all ${isActive ? 'bg-gradient-to-r from-accent-500 to-primary-500 text-white shadow-[0_0_20px_rgba(20,184,166,0.25)]' : 'bg-white dark:bg-white/5 text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-white border border-slate-200 dark:border-white/5 shadow-sm dark:shadow-none hover:border-slate-300 dark:hover:border-white/10'}`} data-id="element-1631">
                <Icon className="w-4 h-4" data-id="element-1632" />
                <span className="hidden sm:inline" data-id="element-1633">{tab.label}</span>
                <span className="sm:hidden" data-id="element-1634">{tab.label.split(' ')[0]}</span>
              </button>;
        })}
        </div>

        {/* Tool Content */}
        <div className="bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-3xl p-4 sm:p-8 shadow-sm dark:shadow-none transition-colors duration-300" data-id="element-1635">
          {activeTab === 'loan' && <LoanCalculator data-id="element-1636" />}
          {activeTab === 'portfolio' && <PortfolioCashflow data-id="element-1637" />}
          {activeTab === 'savings' && <SavingsCalculator data-id="element-1638" />}
          {activeTab === 'budget' && <BudgetPlanner data-id="element-1639" />}
          {activeTab === 'investment' && <InvestmentCalculator data-id="element-1640" />}
        </div>
      </div>
    </main>;
}